
    import React from 'react';
    import ReactDOM from 'react-dom';
    import Component from '/home/circleci/app/packages/categories_menu/src/index';

    const element = typeof document !== 'undefined' && document.querySelector('#LayoutCategoriesMenuComponent-component');

    if (element) {
        const props = window.initialData['LayoutCategoriesMenuComponent'];

        ReactDOM.render(
            <Component {...props}/>,
            element
        );
    }

    export default Component;
    